import React, { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { supabase } from '@/supabaseClient'
import posthog from 'posthog-js'
import { Loader2 } from 'lucide-react'

export function SignupForm({
	className,
	...props
}: React.ComponentProps<"form">) {
	const [formError, setFormError] = useState<string | null>(null)

	const googleSignupMutation = useMutation({
		mutationFn: async () => {
			const { error } = await supabase.auth.signInWithOAuth({
				provider: 'google',
				options: {
					redirectTo: window.location.origin + '/runs',
				},
			})
			if (error) throw error
		},
		onSuccess: () => {
			posthog.capture('user_signed_up', { method: 'google' })
		},
		onError: (error) => {
			setFormError(error.message)
		}
	})

	const signUpWithGoogle = (event: React.FormEvent) => {
		event.preventDefault()
		setFormError(null)
		googleSignupMutation.mutate()
	}

	return (
		<form className={cn("flex flex-col gap-6", className)} onSubmit={signUpWithGoogle} {...props}>
			<div className="flex flex-col items-center gap-2 text-center">
				<h1 className="text-2xl font-bold">Create an account</h1>
				<p className="text-muted-foreground text-sm text-balance">
					Sign up with your Google account to get started
				</p>
			</div>
			<div className="grid gap-6">
				{formError && <p className="text-red-500 text-sm">{formError}</p>}
				<Button type="submit" variant="outline" className="w-full" disabled={googleSignupMutation.isPending}>
					{googleSignupMutation.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
					Sign up with Google
				</Button>
			</div>
			<div className="text-center text-sm">
				Already have an account?{" "}
				<a href="/login" className="underline underline-offset-4">
					Login
				</a>
			</div>
		</form>
	)
}
